import http from "@/utils/request"

//护理员技能
export function gethuliyuan(){
    return http({
        url:'/digital/employeeSkills/treeList',
        method:'get',
    })
}

//获取老人信息报警信息
export function alarmInfo(id){
    return http({
        url:`/care/alarmInfo/${id}`,
        method:'get',
    })
}
//发送报警信息
export function getalarm(){
    return http({
        url:'/alarmInfo/1871846270489231361',
        method:'get',
    })
}

/**
 * 获取护理员列表（用于替换原来的模糊查询）
 * @param {Object} params 查询参数
 * @returns {Promise} 返回包含护理员列表的Promise
 */
export function getAppUserList(params) {
  console.log("getAppUserList函数被调用，参数:", params);

  // 构建完整的请求参数
  const requestParams = {
    ...params,
    systemType: 'care'
  };

  console.log("发送请求参数:", requestParams);
  console.log("请求URL: /system/appUser/systemType/list");

  return http({
    url: '/system/appUser/systemType/list',
    method: 'get',
    params: requestParams
  }).then(response => {
    console.log("getAppUserList接口响应:", response);
    return response;
  }).catch(error => {
    console.error("getAppUserList接口错误:", error);
    throw error;
  });
}